// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3gFiX","success":"Button_success__cnhtV","danger":"Button_danger__1TZk6"};